module.exports = __webpack_public_path__ + "static/media/img_demo_data_desktop.0b1e7178.png";